<script lang="ts">
    import { generatePhraseUrlForAnyDictionary } from "@app/services/url-builder.service";
    import { recentlyViewedTranslations } from "./RecentlyViewed.service";
    import { getMessage } from "@app/services/i18n.service";
    import {
        COMMON__Search_for_translations,
        COMMON__Your_history_is_empty,
    } from "@app/services/i18n.messages";
</script>

<ul>
    {#each $recentlyViewedTranslations.items as item}
        <li class="p-2">
            <div class="text-base">
                <a
                    href={generatePhraseUrlForAnyDictionary({
                        l1: item.l1Code,
                        l2: item.l2Code,
                        phrase: item.phrase,
                    })}
                >
                    {item.phrase}
                </a>
            </div>
            <div class="flex text-xs text-slate-600">
                <div class="flex-1">
                    {item.l1Name} -> {item.l2Name}
                </div>
                <div class="text-right text-xs">
                    {new Date(item.timestamp).toLocaleDateString()}
                    {new Date(item.timestamp).toLocaleTimeString()}
                </div>
            </div>
        </li>
    {/each}
    {#if $recentlyViewedTranslations.items.length === 0}
        <p class="p-4 text-center text-xl">
            {getMessage(COMMON__Your_history_is_empty)}
        </p>
        <p class="p-4 text-center text-xl">
            <a
                href="/"
                class="inline-flex items-center justify-center px-4 py-2 font-medium text-center focus:ring-4 focus:outline-none rounded-lg text-white bg-blue-700 hover:bg-blue-800 focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                >{getMessage(COMMON__Search_for_translations)}</a
            >
        </p>
    {/if}
</ul>
